import React, { useContext, useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import "../../../assets/AdminCss/admin_users.css";
import AdminSidebar from "./AdminSidebar";
import axios from "axios";
import AdminHeader from "./AdminHeader";
import { AuthContext } from "../../../context/Authcontext";
import toast from "react-hot-toast";
import { Modal } from "react-bootstrap"; // ✅ Use React-Bootstrap modal

export const base_url = process.env.REACT_APP_API_URL;

const CustomerWhitelist = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [modal, setModal] = useState({ action: null, id: null });
  const [showModal, setShowModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [error, setError] = useState();
  const [match, setMatch] = useState('');
  const [permit, setPermit] = useState([]);
  const [agents, setAgents] = useState([]);
  const [allAgents, setAllAgents] = useState([]);
  const [formData, setFormData] = useState({
    customerid: "",
    customername: "",
    username: "",
    password: "",
    plain_password:'',
    confirmpassword:'',
    phone: "",
    wallet: 0,
    amount:0,
    currency:"INR",
    status: "Active",
    role: "customer",
    domain: "",
    ip: "",
    project_name: "",
    project_url: "",
    api_type: [],
    ggr:""
  });

  // For See More modal
  const [showSeeMoreModal, setShowSeeMoreModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState("");
  const [currencyList, setCurrencyList] = useState([]);


  const { getRoles } = useContext(AuthContext);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const handleModal = async (action, id) => {
    setModal({ action, id });
    if (action === "edit-customer" && id) {
      const agent = agents.find((a) => a.customerid === id);
      if (agent) {
        setFormData({
          ...formData,
          ...agent,
          api_type: agent.api_type
            ? agent.api_type.split(",").map((x) => x.trim())
            : []
        });
      }
    } else {
    
      try {
        const auth = localStorage.getItem("admin");
        const response = await axios.get(`${base_url}/admin/getNextId`, {
          headers: { Authorization: `${auth}` },
        });
        const nextId = response?.data?.nextCustomerId || 'C1';

        setFormData({
          customerid: nextId,
          customername: "",
          username: "",
          password: "",
          plain_password: '',
          confirmpassword: '',
          phone: "",
          wallet: 0,
          amount: 0,
          currency:"INR",
          status: "Active",
          role: "customer",
          domain: "",
          ip: "",
          project_name: "",
          project_url: "",
          ggr:""
        });
      } catch (err) {
        console.log(err);
        toast.error('Failed to generate next Customer ID');
        setFormData({ /* existing reset */ });
      }
    }
    setShowModal(true);
  };



  useEffect(() => {
  fetchCurrency();
}, []);
const fetchCurrency = async () => {
  try {
    const auth = localStorage.getItem("admin");
    const res = await axios.get(`${base_url}/api/get-currency`, {
      headers: { Authorization: auth },
    });

    console.log(res.data, "res.data");

    if (Array.isArray(res.data)) {
      setCurrencyList(res.data);
    } else {
      toast.error("Failed to load currency!");
    }
  } catch (err) {
    console.log(err);
    toast.error("Currency fetch error");
  }
};


const handleDelete = async (customerid) => {
  const auth = localStorage.getItem("admin");

  // if (!window.confirm("Are you sure you want to delete this customer?")) return;

  try {
    const res = await axios.post(
      `${base_url}/api/admin/updateCustomerStatus`,
      { customerid, deletestatus: 0 },   // 👈 make inactive / delete flag
      { headers: { Authorization: auth } }
    );

    if (res.data.success) {
      toast.success("Customer status updated");
      fetchAgents(); // refresh list
    } else {
      toast.error(res.data.message);
    }

  } catch (err) {
    console.log(err);
    toast.error("Failed to update status");
  }
};



  const handleChange = (e) => {
    const { name, value, checked } = e.target;

    if (name === "api_type") {
      // If it's a checkbox for api_type
      let updatedApiTypes = [...(formData.api_type || [])];

      if (checked) {
        // Add value if not already in array
        if (!updatedApiTypes.includes(value)) {
          updatedApiTypes.push(value);
        }
      } else {
        // Remove value if unchecked
        updatedApiTypes = updatedApiTypes.filter((item) => item !== value);
      }

      setFormData({
        ...formData,
        api_type: updatedApiTypes,
      });
    } else {
      // Default behaviour for other fields
      const updatedForm = { ...formData, [name]: value };
      setFormData(updatedForm);

      const { plain_password, confirmpassword } = updatedForm;

      if (modal.action === "add-customer") {
        if (plain_password && confirmpassword) {
          if (plain_password === confirmpassword) {
            setMatch(""); // ✅ passwords match
          } else {
            setMatch("Password and Confirm Password do not match");
          }
        } else {
          setMatch("");
        }
      }
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    const auth = localStorage.getItem("admin");
    try {
      const requiredFields = [
        "customerid",
        "customername",
        "username",
        "plain_password",
        "phone",
        "role",
        "domain",
        "ip",
        "project_name",
        "project_url",
        "ggr"
      ];

      for (let field of requiredFields) {
        if (!formData[field] || formData[field] === "") {
          return toast.error(`${field.replace("_", " ")} is required`);
        }
      }


      let response;
      if (modal.action === "add-customer") {
        response = await axios.post(`${base_url}/admin/addCustomers`, formData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        });
      } else if (modal.action === "edit-customer") {
        response = await axios.post(`${base_url}/admin/editCustomers`, formData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        });
      }
      if (response?.data.success) {
        toast.success(response?.data?.message);
        setShowModal(false);
        fetchAgents();
      }else{
        toast.error(response?.data?.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchRoles = useCallback(async () => {
    const auth = localStorage.getItem("admin");
    const role = localStorage.getItem("role");
    try {
      const roles = await getRoles(auth, role);
      let allPermit = [];
      Object.values(Object.values(roles[0])[0]).forEach((roleObj) => {
        Object.values(roleObj).forEach((perm) => {
          allPermit.push(...Object.values(perm));
        });
      });
      setPermit(allPermit);
    } catch (error) {
      setError(error.message);
    }
  }, []);

  const fetchAgents = useCallback(async () => {
    const auth = localStorage.getItem("admin");
    try {
      const response = await axios.get(`${base_url}/admin/getCustomers`, {
        headers: { Authorization: `${auth}` },
      });
      if (response?.data?.success) {
        const data = response?.data?.agents;
        setAgents(data);
        setAllAgents(data);
      }
    } catch (err) {
      console.log(err);
    }
  }, []);

  const handleSearch = (e) => {
    const search = e.target.value.toLowerCase();
    if (search === "") {
      setAgents(allAgents);
      return;
    }
    const filteredData = allAgents?.filter((value) => {
      if (
        value.customerid.toLowerCase().includes(search) ||
        value.customername.toLowerCase().includes(search) ||
        value.project_name.toLowerCase().includes(search) ||
        value.domain.toLowerCase().includes(search)
      ) {
        return value;
      }
      return false;
    });
    setAgents(filteredData);
  };

  const handleSeeMore = (title, content) => {
    setModalTitle(title);
    setModalContent(content);
    setShowSeeMoreModal(true);
  };

  const truncateText = (text, length = 20) => {
    if (!text) return "";
    return text.length > length ? text.slice(0, length) + "..." : text;
  };

  useEffect(() => {
    fetchRoles();
    fetchAgents();
  }, [fetchRoles, fetchAgents]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (error) return <p className="text-danger">{error}</p>;

  return (
    <>
      <div className="wrapper bg-light min-vh-100">
        <AdminSidebar
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          isMobile={isMobile}
        />
        <AdminHeader
          toggleSidebar={toggleSidebar}
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />

        <div
          className={`content-wrapper ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
        >
          <div className="px-3 py-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h1 className="h4 text-dark">
                <i className="fa fa-users text-primary me-2" />
                Customer Whitelisted
              </h1>
              <button
                onClick={() => handleModal("add-customer", null)}
                className="btn btn-primary"
              >
                <i className="fa fa-plus me-1" /> Add Customer
              </button>
            </div>

            <div className="w-100 my-3 rounded">
              <input
                type="text"
                placeholder="Enter Customer ID or Customer Name or Project Name or Domain name"
                name="search"
                className="form-control rounded"
                onChange={handleSearch}
              />
            </div>

            <div className="table-responsive bg-white shadow-sm rounded">
              <table className="table table-striped table-hover bg-gray">
                <thead className="table-light bg-gray text-nowrap">
                  <tr className="text-center border">
                    <td className="border fw-bold p-3">Customer ID</td>
                    <td className="border fw-bold p-3">Customer Name</td>
                    <td className="border fw-bold p-3">Username</td>
                    <td className="border fw-bold p-3">Password</td>
                    <td className="border fw-bold p-3">Phone</td>
                    <td className="border fw-bold p-3">Wallet</td>
                    <td className="border fw-bold p-3">Status</td>
                     <td className="border fw-bold p-3">Currency</td>
                    <td className="border fw-bold p-3">Verify Key</td>
                    <td className="border fw-bold p-3">Secret Key</td>
                    <td className="border fw-bold p-3">API Type</td>
                    <td className="border fw-bold p-3">Project IP</td>
                    <td className="border fw-bold p-3">Domain Name</td>
                    <td className="border fw-bold p-3">Project Name</td>
                    <td className="border fw-bold p-3">Project URL</td>
                                        <td className="border fw-bold p-3">ggr</td>

                    <td className="border fw-bold p-3">Created By</td>
                    <td className="border fw-bold p-3">Date</td>
                    <td className="border fw-bold p-3">Action</td>
                  </tr>
                </thead>
                <tbody>
                  {agents.map((agent) => (
                    <tr key={agent.customerid} className="text-center border">
                      <td className="border">{agent.customerid}</td>
                      <td className="border">{agent.customername}</td>
                      <td className="border">{agent.username}</td>
                      <td className="border">{agent.plain_password}</td>
                      <td className="border">{agent.phone}</td>
                      <td className="border">{agent.wallet}</td>
                      <td className="border">{agent.status}</td>
                       <td className="border">{agent.currency}</td>

                      {/* Public Key */}
                      <td className="border cursor-pointer" onClick={() =>
                            handleSeeMore("Public Key", agent.public_key)
                        }>
                        {truncateText(agent.public_key)}
                        {agent.public_key?.length > 20 && (
                          <button
                            className="border-0 p-0 ms-1"
                            style={{fontSize:'10px', color:'gray', textDecoration:'underline'}}
                            onClick={() =>
                              handleSeeMore("Public Key", agent.public_key)
                            }
                          >
                            See More
                          </button>
                        )}
                      </td>

                      {/* Private Key */}
                      <td className="border cursor-pointer" onClick={() =>
                            handleSeeMore("Private Key", agent.private_key)
                        }>
                        {truncateText(agent.private_key)}
                        {agent.private_key?.length > 20 && (
                          <button
                            className="border-0 p-0 ms-1"
                            style={{fontSize:'10px', color:'gray', textDecoration:'underline'}}
                            onClick={() =>
                              handleSeeMore("Private Key", agent.private_key)
                            }
                          >
                            See More
                          </button>
                        )}
                      </td>
                      <td className="border">{agent.api_type}</td>

                      <td className="border">{agent.ip}</td>
                      <td className="border">{agent.domain}</td>
                      <td className="border">{agent.project_name}</td>
                      <td className="border">{agent.project_url}</td>

                                            <td className="border">{agent.ggr}</td>

                      <td className="border">{agent.created_by}</td>
                      <td className="border">{agent.date?.slice(0, 10)}</td>
                     <td className="text-center" style={{ padding: "6px 0", verticalAlign: "middle" }}>
  <div className="d-flex justify-content-center gap-2">

    <button
      onClick={() => handleModal("edit-customer", agent.customerid)}
      className="btn btn-sm btn-outline-primary px-3 py-1"
    >
      Edit
    </button>

    <button
      onClick={() => handleDelete(agent.customerid)}
      className="btn btn-sm btn-outline-danger px-3 py-1"
    >
      Delete
    </button>

  </div>
</td>


                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.4)",
            backdropFilter: "blur(4px)",
          }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content shadow-lg border-0 rounded-4 overflow-hidden">
              
              {/* Modal Header with Gradient */}
              <div
                className="modal-header text-white"
                style={{
                  background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
                  borderBottom: "none",
                }}
              >
                <h5 className="modal-title fw-bold">
                  {modal.action === "add-customer" ? "➕ Add New Customer" : "✏️ Edit Customer"}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body p-4 bg-light">
                <form onSubmit={handleSubmit}>
                  <div className="row g-3">

                    {match && (
                      <div className='text-center text-red'>{match}</div>
                    )}

                    <div className="col-md-4 col-sm-6 col-12">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Customer ID</label>
                      <input type="text" placeholder="Enter Customer ID" name="customerid" value={formData.customerid} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)} readOnly/>
                    </div>

                    <div className="col-md-4 col-sm-6 col-12">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Customer Name</label>
                      <input type="text" placeholder="Enter customer name" name="customername" value={formData.customername} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)}/>
                    </div>

                    <div className="col-md-4 col-sm-6 col-12">
                      <label className="form-label text-capitalize fw-semibold text-secondary">UserName</label>
                      <input type="text" placeholder="Enter username" name="username" value={formData.username} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)}/>
                    </div>

                    <div className="col-md-4 col-sm-6 col-12">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Password</label>
                      <div className="position-relative">
                        <input
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter password"
                          name="plain_password"
                          value={formData.plain_password}
                          className="form-control rounded-pill shadow-sm pe-5"
                          onChange={(e) => handleChange(e)}
                        />
                        <i
                          className={`fa ${showPassword ? "fa-eye" : "fa-eye-slash"} position-absolute`}
                          style={{ right: "15px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }}
                          onClick={() => setShowPassword(!showPassword)}
                        ></i>
                      </div>
                    </div>

                    {modal.action === "add-customer" && (<div className="col-md-4 col-sm-6 col-12">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Confirm Password</label>
                      <div className="position-relative">
                        <input
                          type={showPassword1 ? "text" : "password"}   // 👈 toggle input type
                          placeholder="Enter password"
                          name="confirmpassword"
                          value={formData.confirmpassword}
                          className="form-control rounded-pill shadow-sm pe-5"
                          onChange={(e) => handleChange(e)}
                        />
                        <i
                          className={`fa ${showPassword1 ? "fa-eye" : "fa-eye-slash"} position-absolute`}
                          style={{ right: "15px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }}
                          onClick={() => setShowPassword1(!showPassword1)}
                        ></i>
                      </div>
                    </div>)}

                    <div className="col-md-4 col-sm-6 col-12">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Phone</label>
                      <input type="text" placeholder="Enter phone" name="phone" value={formData.phone} maxLength={10} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)} readOnly={modal.action === "edit-agent"} />
                    </div>

                    {/* <div className="col-4">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Secret Key</label>
                      <input type="text" placeholder="Enter Agent ID" name="secret_key" value={formData.secret_key} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)}/>
                    </div>

                    <div className="col-4">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Verify Key</label>
                      <input type="text" placeholder="Enter Agent ID" name="verify_key" value={formData.verify_key} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)}/>
                    </div> */}

                    <div className="col-md-4 col-sm-6 col-12">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Wallet</label>
                      <input type="text" placeholder="Enter wallet" name="wallet" value={formData.wallet} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)}/>
                    </div>

                    <div className="col-md-4 col-sm-6 col-12">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Amount</label>
                      <input type="text" placeholder="Enter wallet" name="amount" value={formData.amount } className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)}/>
                    </div>

                    <div className="col-md-4 col-sm-6 col-12">
  <label className="form-label text-capitalize fw-semibold text-secondary">
    Currency
  </label>

 <select
  name="currency"
  className="form-select rounded-pill shadow-sm"
  value={formData.currency}
  onChange={handleChange}
>
  <option value="">Select Currency</option>

  {currencyList.map((c) => (
    <option key={c.id} value={c.currency}>
      {c.currency}
    </option>
  ))}
</select>

</div>



                    <div className="col-md-4 col-sm-6 col-12">
                      <label className="form-label fw-semibold text-secondary">API Access</label>
                      <div>
                        <label className="me-3 text-black">
                          <input
                            type="checkbox"
                            name="api_type"
                            value="casino"
                            checked={formData.api_type?.includes("casino")}
                            onChange={handleChange}
                          />{" "}
                          Casino
                        </label>
                        <label className="me-3 text-black">
                          <input
                            type="checkbox"
                            name="api_type"
                            value="sports"
                            checked={formData.api_type?.includes("sports")}
                            onChange={handleChange}
                          />{" "}
                          Sports
                        </label>
                      </div>
                    </div>


                    <div className="col-md-4 col-sm-6 col-12">
                      <label className="form-label text-capitalize fw-semibold text-secondary">
                        Status
                      </label>

                      <select
                        value={formData.status}
                        name="status"
                        onChange={handleChange} // ✅ Moved here
                        className="form-select rounded shadow-sm border border-secondary"
                        style={{
                          backgroundColor: "#fff",
                          fontWeight: "500",
                          padding: "6px 8px",
                        }}
                      >
                        <option value="Active">Active</option>
                        <option value="InActive">InActive</option>
                        <option value="Suspended">Suspended</option>
                      </select>
                    </div>

                    <div className="col-md-4 col-sm-6 col-12">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Role</label>
                      <input type="text" placeholder="Enter Role" name="role" value={formData.role} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)} readOnly={modal.action === "edit-customer"} />
                    </div>


                    {modal.action !== "add-customer" && (<div className="col-md-4 col-sm-6 col-12">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Time</label>
                      <input type="text"  name="time" value={(formData.date)?.slice(0, 10)} className="form-control rounded-pill shadow-sm" readOnly/>
                    </div>)}

                    <div className="col-md-4 col-sm-6 col-12">
                      <label className="form-label text-capitalize fw-semibold text-secondary">IP</label>
                      <input type="text" placeholder="Enter IP" name="ip" value={formData.ip} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)}/>
                    </div>

                        <div className="col-md-4 col-sm-6 col-12">
                      <label className="form-label text-capitalize fw-semibold text-secondary">ggr</label>
                      <input type="text" placeholder="Enter ggr" name="ggr" value={formData.ggr} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)}/>
                    </div>

                    <div className="col-md-4 col-sm-6 col-12">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Domain Name</label>
                      <input type="text" placeholder="Enter Domain name" name="domain" value={formData.domain} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)}/>
                    </div>

                    <div className="col-md-4 col-sm-6 col-12">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Project Name</label>
                      <input type="text" placeholder="Enter project name" name="project_name" value={formData.project_name} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)}/>
                    </div>

                    <div className="col-md-4 col-sm-6 col-12">
                      <label className="form-label text-capitalize fw-semibold text-secondary">Project URL</label>
                      <input type="text" placeholder="Enter project base url" name="project_url" value={formData.project_url} className="form-control rounded-pill shadow-sm" onChange={(e)=>handleChange(e)}/>
                    </div>




                    {/* {Object.entries(formData).map(([key, value]) =>
                      key !== "agentid" || modal.action === "edit-agent" ? (
                        <div
                          className="col-md-6"
                          key={key}
                          style={{ animation: "fadeInUp 0.3s ease" }}
                        >
                          <label className="form-label text-capitalize fw-semibold text-secondary">
                            {key === 'time' ? '' : key.replace("_", " ")}
                          </label>
                          <input
                            type={key === "password" ? "password" : key === 'time' ? '' : "text"}
                            name={key === 'time' ? '' : key}
                            value={value}
                            onChange={handleChange}
                            // readOnly={["agentid", "time", "ip"].includes(key)}
                            className={`form-control rounded-pill shadow-sm`}
                          />
                        </div>
                      ) : null
                    )} */}
                  </div>

                  {/* Footer Actions */}
                  <div className="text-end mt-4">
                    <button
                      type="button"
                      onClick={() => setShowModal(false)}
                      className="btn btn-outline-secondary rounded-pill px-4 me-2 shadow-sm"
                    >
                      ❌ Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn text-white rounded-pill px-4 shadow-sm"
                      style={{
                        background: "linear-gradient(135deg, #ff512f 0%, #dd2476 100%)",
                        border: "none",
                      }}
                    >
                      💾 Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* See More Modal */}
      <Modal
        show={showSeeMoreModal}
        onHide={() => setShowSeeMoreModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
            {modalContent}
          </pre>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CustomerWhitelist;
